export default "__VITE_ASSET__DZgN8jC7__"